const selector = '.agent,.agent-parent'
const className = 'animate'
let observer
let entry

function addAnimationClass(entries) {
  for (let i = 0, l = entries.length; i < l; i++) {
    entry = entries[i]

    if (entry.isIntersecting === false) continue

    entry.target.classList.add(className)
    observer.unobserve(entry.target)
  }
}

export default function directAgents() {
  const agents = document.querySelectorAll(selector)

  if (!agents || agents.length === 0) return
    
  observer = new IntersectionObserver(addAnimationClass, {
    rootMargin: '-' + (window.innerHeight * 0.25) + 'px 0px'
  })

  for (let i = 0, l = agents.length; i < l; i++) observer.observe(agents[i])
}
